import { render, staticRenderFns } from "./mostProducts.vue?vue&type=template&id=f163ee88&"
import script from "./mostProducts.vue?vue&type=script&lang=js&"
export * from "./mostProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports